import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { AutopilotAutomationBaseComponent } from '../autopilot-automation.component'
import { ConfirmDialogService, SaveForm, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { Actions, ofType } from '@ngrx/effects'
import { AutomationWizardCloseAction, AutomationWizardSaveAction } from '../../automations-wizard.actions'
import { filter } from 'rxjs/operators'

@Component({
  selector: 'app-do-action-automation',
  templateUrl: './do-action-automation.component.html',
  styleUrls: ['./do-action-automation.component.scss'],
})
export class DoActionAutomationComponent extends AutopilotAutomationBaseComponent implements OnInit {
  @Input() templateId: string
  constructor(
    private actions: Actions,
    protected store: Store<any>,
    protected amplitudeService: AmplitudeService,
    protected confirm: ConfirmDialogService
  ) {
    super(store, amplitudeService, confirm)
  }

  ngOnInit(): void {
    super.ngOnInit()

    this.actions
      .pipe(
        ofType(AutomationWizardSaveAction),
        filter(() => this.viewType !== 'table'),
        untilDestroy(this)
      )
      .subscribe((action) => {
        if (this.automationGroup) {
          this.doSave(this.form, action.closeAfterSave)
        } else if (action.closeAfterSave) {
          this.store.dispatch(AutomationWizardCloseAction())
        }
      })
  }

  tryToCreateOrUpdateAutomation(status: boolean) {
    if (this.automationGroup) {
      this.toggleAutomation(status)
    } else {
      this.doSave(this.form)
    }
  }

  @SaveForm()
  doSave(form: FormGroup, closeAfterSave = false) {
    this.saveAutomation({ ...form.getRawValue(), template: this.templateId })
    if (closeAfterSave) {
      this.store.dispatch(AutomationWizardCloseAction())
    }
  }

  getAutopilotId() {
    return `autopilot-do-action|${this.service}|${this.type}|${this.event}|${this.handler}|${this.idSuffix || ''}`
  }
}
